import { action } from 'satcheljs';

export const onDiscoverManifestFetched = action('ON_DISCOVER_MANIFEST_FETCHED');
